const ProfessionalTypes = {
    $container: null,
    $tabs: null,
    $menuItems: null,
    $select: null,

    init() {
        this.$container = document.querySelector('.js-professional-types');
        if (this.$container) {
            this.$tabs = this.$container.querySelectorAll('.js-professional-types-tab');
            this.$menuItems = this.$container.querySelectorAll('.js-professional-types-menu-item');
            this.$select = this.$container.querySelector('.js-professional-types-menu-select');

            this.initMenu();
            this.initSelect();
            this.initDefaultTab();
            this.initHistoryEvents();
        }
    },

    initMenu() {
        const that = this;

        this.$menuItems.forEach($menuItem => {
            const tabId = $menuItem.dataset.tab;

            $menuItem.addEventListener('click', e => {
                that.onClickMenuItem(tabId);

                const hash = '#/' + tabId;
                window.history.pushState(null, null, hash);
            });
        });
    },

    onClickMenuItem(tabId) {
        this.$menuItems.forEach($item => {
            if ($item.dataset.tab === tabId) {
                $item.classList.add('active');
            } else {
                $item.classList.remove('active');
            }
        });

        this.$tabs.forEach($tab => {
            if ($tab.id === tabId) {
                $tab.classList.add('active');
            } else {
                $tab.classList.remove('active');
            }
        });

        this.$select.value = tabId;

        const event = new CustomEvent('professionalTypeChanged', {detail: {tabId}});
        document.dispatchEvent(event);
    },

    initSelect() {
        const that = this;

        this.$select.addEventListener('change', e => {
            const tabId = that.$select.value;

            that.$menuItems.forEach($menuItem => {
                if ($menuItem.dataset.tab === tabId) {
                    $menuItem.click();
                }
            });

            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 50);
        });
    },

    initDefaultTab() {
        this.changeTabFromHash().then(tabId => {
            const hash = '#/' + tabId;
    
            window.history.replaceState(null, null, hash);
        });
    },

    initHistoryEvents() {
        const that = this;

        window.addEventListener('popstate', e => {
            if (e.target.location.pathname === window.location.pathname) {
                that.changeTabFromHash();
            }
        });
    },

    changeTabFromHash() {
        return new Promise((resolve, reject) => {
            const tabId = window.location.hash.replace('#/', '');
    
            const $menuItemsFiltered = Array.prototype.filter.call(this.$menuItems, $item => $item.dataset.tab === tabId);
            const $menuItem = typeof $menuItemsFiltered[0] !== 'undefined' ? $menuItemsFiltered[0] : this.$menuItems[0];

            this.onClickMenuItem($menuItem.dataset.tab);

            if (!tabId) {
                const hash = '#/' + $menuItem.dataset.tab;
                window.history.replaceState(null, null, hash);
            }

            resolve($menuItem.dataset.tab);
        });
    }
}

export default ProfessionalTypes;